module.exports = __webpack_public_path__ + "img/not-found-image.1c6047a3.png";